import React, { Component } from 'react'

import Notifier from '../aside/Notifier';
import ErrorNotifier from '../aside/ErrorNotifier';
import {Modal,Button} from 'react-bootstrap'


import { Form } from "reactstrap";

import FormComponent from "../../common/FormComponent";
import {addCandidateReferal} from "../../redux/action/jobs/refer_candidateAction"
import {getProfileInfo} from "../../redux/action/profileInfoAction"

import{
  Validator,
  submitValidator,
  valid,
  refresh,
  
} from "../../common/Validator"
import { connect } from 'react-redux';



// Refer Candidate component
 class AddReferCandidate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      candidateName: "",
      phone:"",
      comment:"",
      mailId:"",
      refferedBy:"",
      status:"",
   
      dateError:"",
      error:"",
      message:"",
    };
 
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this)

    // this.getDataPrimSec = this.getDataPrimSec.bind(this)
  }

  // onSumbit function trigering
 onSubmit(e) {
   e.preventDefault();
    submitValidator(e.target);
   let data = {
      jobReqirementId: this.props.reqId,
      canName: this.state.candidateName,
      canEmailId: this.state.mailId,
      comments:this.state.comment,
      phone:this.state.phone,
      referredby: `${this.props.profile.data.firstName} ${this.props.profile.data.lastName}`,
      status:this.state.status
    };

    if(valid){
   this.props.addCandidateReferal(data,this.props.handleCloseModal)
    }
    else{
      console.log("chandrahshdh")
      this.setState({
        error: "Please enter all mandatory fields",
      });
      setTimeout(() => {
        this.setState({
          error: "",
        });
      }, 2000);
    }
  }
  onChange(e) {
    Validator(e.target);
     this.setState({
       [e.target.name]: e.target.value,
     });
     console.log(e.target.value);
   }

   componentDidMount(){
    refresh()
    this.props.getProfileInfo()
   }
 


  render() {
    console.log(this.props.ReferCandidate)
   return (
     <div>
       <Modal
         size="lg"
         show={this.props.showPopUp}
         onHide={this.props.handleCloseModal}
       >
         <i
           data-toggle="tooltip"
           data-placement="top"
           title="Close"
           onClick={this.props.handleCloseModal}
           className="material-icons pointer cancel-button"
         >
           cancel
         </i>

         {/* <Form onSubmit={this.handleSubmitData} className="p-3 mt-2" noValidate> */}
         <div
           style={{
             display: "flex",
             justifyContent: "center",
             alignItems: "center",
             marginTop: "1rem",
           }}
         >
           <Modal.Title>Refer Candidate</Modal.Title>
         </div>

         <div style ={{width:"100%",display:"flex",justifyContent:"center"}}>
         
           <div style={{width:"50%"}}>
           <Form onSubmit={this.onSubmit} className="p-3" noValidate>
               <FormComponent
                  labelClass="bold label-sm"
                  label=" Candidate Name"
                  index="16"
                 type="text"
                 name="candidateName"
                 required={true}
                 change={this.onChange}
                 value={this.state.candidateName}
               />
                  <FormComponent
                   labelClass="bold label-sm"
                   label="Email Id"
                  index="16"
                  type="email"
                  name="mailId"
                  required={true}
                  change={this.onChange}
                  value={this.state.mailId}
               />

              <FormComponent
                 labelClass="bold label-sm"
                 label="Mobile No."
           
                index="16"
                type="tel"
                name="phone"
                required={true}
                change={this.onChange}
                value={this.state.phone}
               />

               <FormComponent
                 labelClass="bold label-sm"
                 label="Comments"
                 index="16"
                 type="text"
                 name="comment"
                 change={this.onChange}
                 value={this.state.comment}
               />
                <div
           style={{
             display: "flex",
             justifyContent: "center",
             alignItems: "center",
             marginTop:"1rem"
           }}
         >
           <Button  type="submit" variant="primary">Submit</Button>
         </div>
            </Form>
           </div>
         </div>

        
       </Modal>
       {this.props.ReferCandidate.message && <Notifier message={this.props.ReferCandidate.message} />}
            {this.state.error && <ErrorNotifier message={this.state.error} />}
     </div>
   );
  }
}
const mapStateToProps = (state) => ({
  ReferCandidate: state.ReferCandidate,
  profile: state.profile,
});


export default connect(mapStateToProps,{
  addCandidateReferal,
  getProfileInfo
})(AddReferCandidate)





